import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

/* eslint-disable max-lines */
import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import tableMixin from './table-mixin.js';
import Pagination from '@/components/Pagination/index.vue';
import PreviewDialog from '@pt/components/previewDialog/index.vue';
import { getSizerOption, getPlayableStatList, getPlayableStatCount } from '@/api/report/creative';
import { getCountryList as _getCountryList } from '@/api/common/country';
import { format, subDays } from 'date-fns';
// import { isDevelopment, isTest, isProduction } from '@com/config/env'
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { cookRequestParams } from '@/common/request';

var defaultSearchField = ['impression', 'click', 'install', 'revenue', 'ctr', 'cvr', 'ivr', 'ecpm'];

var generateId = function generateId() {
  return Math.random() * new Date().getTime();
};

export default {
  mixins: [searchMixin, tableMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination,
    PreviewDialog: PreviewDialog
  },

  data: function data() {
    return {
      query: {
        page: 1,
        page_size: 50,
        time: [format(subDays(new Date(), 2), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')], // 时间
        group_fields: ['creative_type'],
        search_fields: [].concat(defaultSearchField),
        lastSearchFields: [],
        ad_types: '',
        adv_creative_id: '',
        adv_creative_name: '',
        agg_type: 'sum',
        app_id: '',
        app_name: '',
        country_codes: '',
        creative_types: '',
        dco_id: '',
        get_sum: 1,
        is_dco: '',
        mid: '',
        order: '',
        package_name: '',
        platforms: '',
        project_name: '',
        provider_ids: '',
        pt_adv_ids: '',
        traffic_type: '',
        ss_adv_ids: '',
        template_id: '',
        template_name: '',
        tz: '',
        uuid: '',
        offer_id: '',
        basic_id: '',
        demand_id: ''
      },

      lastQuery: '',

      preview: {
        title: '',
        visible: false,
        url: ''
      },
      previewUrl: '',

      creativeProvider: [], // 提供商列表
      adTypeList: [],
      countryList: [],
      list: [],
      listLoading: false,
      exportLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      selectDate: '',

      pagination: {
        total: 0
      },

      maxExportNumber: 1000000,

      visibleColumns: [],
      filterBarVisible: false,
      tableSum: ''
    };
  },


  computed: {},

  watch: {
    $route: function $route(to, from) {
      this.getMaterialReport();
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getAdTypeList();
              _this.getCountryList();
              _context.next = 4;
              return _this.$store.dispatch('config/getTimeZoneList');

            case 4:
              _this.query.tz = _this.$route.query.tz || '8';
              _context.next = 7;
              return _this.$store.dispatch('config/getCreativeProvider');

            case 7:
              _this.creativeProvider = _context.sent;


              // 获取列表
              _this.getMaterialReport();

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    groupFieldCanCheck: function groupFieldCanCheck(item) {
      return this.query.group_fields.length === 1 && this.query.group_fields.indexOf(item.value) > -1 || this.query.group_fields.length === 5 && this.query.group_fields.indexOf(item.value) === -1;
    },
    handleSearchFieldChange: function handleSearchFieldChange() {
      var _this2 = this;

      if (['actions', 'scenes'].every(function (item) {
        return _this2.query.search_fields.includes(item);
      })) {
        if (this.lastSearchFields.includes('actions')) {
          this.query.search_fields = this.query.search_fields.filter(function (item) {
            return item !== 'actions';
          });
        } else if (this.lastSearchFields.includes('scenes')) {
          this.query.search_fields = this.query.search_fields.filter(function (item) {
            return item !== 'scenes';
          });
        }
      }
      this.lastSearchFields = this.query.search_fields;
    },
    changePreviewUrl: function changePreviewUrl(_ref) {
      var group = _ref.group;

      this.previewUrl = group.dco_preview_url;
    },
    exportSheet: function exportSheet() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var postData, resCount;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 总数接口
                _this3.exportLoading = true;
                postData = _this3.cookQuery(_this3.query);
                _context2.prev = 2;
                _context2.next = 5;
                return getPlayableStatCount(postData);

              case 5:
                resCount = _context2.sent;

                _this3.exportLoading = false;
                _this3.pagination.total = _.get(resCount, 'data.data.total') || 0;

                if (!(_this3.pagination.total >= _this3.maxExportNumber)) {
                  _context2.next = 11;
                  break;
                }

                _this3.$message({
                  message: '数据量超过100w，限制导出',
                  type: 'error'
                });
                return _context2.abrupt('return');

              case 11:
                downloadWithNewWindow(v2Host + '/report/playable-stat/export?' + qs.stringify(_extends({}, cookRequestParams(_extends({}, postData)))));
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](2);

                console.log(_context2.t0);
                _this3.exportLoading = false;

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 14]]);
      }))();
    },
    handleSortChange: function handleSortChange(_ref2) {
      var column = _ref2.column,
          prop = _ref2.prop,
          order = _ref2.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    getMaterialReport: function getMaterialReport() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var order, AllSelected, unSelectedBasic, unSelectedScene, unSelectedAction, postData, res, sum, relatedFields;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.listLoading = true;
                order = _this4.query.order.replace('-', '');
                AllSelected = [].concat(_toConsumableArray(_this4.query.search_fields), _toConsumableArray(_this4.query.group_fields));
                // 排序属性未被选中

                unSelectedBasic = AllSelected.indexOf('basics') === -1 && _this4.basicList.some(function (item) {
                  return item.prop === order;
                });
                unSelectedScene = AllSelected.indexOf('scenes') === -1 && _this4.sceneList.some(function (item) {
                  return item.prop === order;
                });
                unSelectedAction = AllSelected.indexOf('actions') === -1 && _this4.actionList.some(function (item) {
                  return item.prop === order;
                });

                if (AllSelected.indexOf(order) === -1 && order !== 'date' && (unSelectedBasic || unSelectedScene || unSelectedAction)) {
                  _this4.query.order = '';
                }
                _context3.prev = 7;

                // 列表接口，判断请求参数是否与上一次请求参数一致，请求参数一致需要回传last_total，不一致last_total为0
                postData = _this4.cookQuery(_this4.query);

                if (_JSON$stringify(_.omit(postData, 'page')) === _this4.lastQuery) {
                  postData.last_total = _this4.pagination.total;
                } else {
                  _this4.lastQuery = _JSON$stringify(_.omit(postData, 'page'));
                  postData.last_total = 0;
                }
                _context3.next = 12;
                return getPlayableStatList(_extends({}, postData));

              case 12:
                res = _context3.sent;
                sum = void 0;

                if (_.get(res, 'data.data.sum')) {
                  sum = _extends({
                    date: 'sum'
                  }, _.get(res, 'data.data.sum'));
                  // 不统计字段，默认值处理
                  _this4.dataDimension.map(function (item) {
                    return item.value;
                  }).forEach(function (val) {
                    sum[val] = '-';
                  });
                } else {
                  sum = '';
                }
                _this4.tableSum = sum || _this4.tableSum;
                if (_.get(res, 'data.data.list')) {
                  _this4.list = (_this4.tableSum ? [_this4.tableSum] : []).concat(_.get(res, 'data.data.list') || []).map(function (item) {
                    return _extends({}, item, {
                      _id: generateId()
                    });
                  });
                } else {
                  _this4.list = [];
                }
                _this4.visibleColumns = [].concat(_toConsumableArray(_this4.query.search_fields), _toConsumableArray(_this4.query.group_fields));
                // 部分筛选字段可能需要显示联动字段
                relatedFields = {
                  template_id: ['template_name']
                };

                _.each(relatedFields, function (fields, key) {
                  if (_this4.visibleColumns.includes(key)) {
                    _this4.visibleColumns = _this4.visibleColumns.concat(fields);
                  }
                });
                _this4.pagination.total = _.get(res, 'data.data.total') || 0;
                _this4.listLoading = false;
                _context3.next = 27;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3['catch'](7);

                _this4.listLoading = false;

              case 27:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[7, 24]]);
      }))();
    },
    getAdTypeList: function getAdTypeList(params) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return getSizerOption(_extends({ sizer: 'ad_type' }, params));

              case 3:
                res = _context4.sent;

                // 只要interstitial video以及rewarded video数据
                _this5.adTypeList = (_.get(res, 'data.data.name') || []).filter(function (item) {
                  return item === 'rewarded video' || item === 'interstitial video';
                }).map(function (item) {
                  return {
                    value: item,
                    label: item
                  };
                });
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                _this5.adTypeList = [];

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 7]]);
      }))();
    },
    cookQuery: function cookQuery(params) {
      // 接口请求不需要group_fields 字段
      var temp = _extends({}, params);
      temp.search_fields = params.search_fields.concat(params.group_fields);
      delete temp.group_fields;
      return temp;
    },
    hanadlePreview: function hanadlePreview(item) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.preview = _extends({
                  isDCO: false,
                  visible: true,
                  title: _this6.$t('playTurbo.report.query.preview')
                }, item, {
                  name: item.adv_creative_name || ''
                });
                _this6.previewUrl = item.preview_url + '?preview=true';

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    getCountryList: function getCountryList() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _getCountryList();

              case 3:
                res = _context6.sent;

                _this7.countryList = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return {
                    value: item.code,
                    label: item.name + (' (' + item.code + ')')
                  };
                });
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);

                _this7.countryList = [];

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[0, 7]]);
      }))();
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    resetSearch: function resetSearch() {
      this.query.search_fields = [].concat(defaultSearchField);
      this.query.group_fields = ['creative_type'];
      this.query.agg_type = 'sum';
      this.query.get_sum = 1;
      this.query.tz = '8';
      this.handleResetSearch();
    }
  }
};